import React from 'react';
import { CostCentre } from 'types/scenario';
import Text from '@ingka/text';
import classes from './CoworkerDetails.module.scss';

const CoworkerCostCentreList = ({ title, costCentres }: { title: string; costCentres: CostCentre[] }) => (
    <div className={classes.value} data-testid="coworker-details-cost-centers">
        <Text data-testid="coworker-details-cost-centers-title" textStyle="Heading.XS">{title}</Text>
        {costCentres.map(cc => (
            <div key={cc.costCentre} className={cc.sourceIsPa ? '' : classes['scenario-details']}>
                <Text data-testid="coworker-details-cost-centers-display-name" textStyle="Body.M">{cc.displayName}</Text>
            </div>
        ))}
    </div>
);

export default CoworkerCostCentreList;
